// extracted by mini-css-extract-plugin
module.exports = {"container":"TextBlock_container__QqzUz","text-align-left":"TextBlock_text-align-left__HxSik","text-align-right":"TextBlock_text-align-right__Uwp_X"};